export enum PolicyQueryKeys {
  CompanyList = 'companyList',
  PolicyList = 'policyList'
}
